module.exports = {
  home: '主页',
  appproducts: '所有产品',
  helloworld: '你好，世界',
  helloman: '你好，{name}',
  iphones: '苹果5 | 苹果6 | 苹果7'
}
